<script type="ts">
import type { RenderOptions } from '../browser';
import { RenderMetadata, getOptionsToPrefix as prefix } from '../browser';

export let options: RenderOptions;
export let image: string;

let expandHeight = false;
let enableAdvanced = false;

const yesno = (a) => {
    return a ? 'yes' : 'no';
}
</script>

<div class="img-frame">
    {#if prefix(options) in RenderMetadata}
        {#if image in RenderMetadata[prefix(options)]}
        <div class="img-frame-metadata">
            <h3>{image}</h3>
            <div><b>dimensions:</b> ({RenderMetadata[prefix(options)][image].shape.join(', ')})</div>
            <div><b>cropped:</b> {yesno(RenderMetadata[prefix(options)][image].cropped)}</div>
            {#if RenderMetadata[prefix(options)][image].cropped}
            <div class="img-frame-tabbed">
                <div><b>1st pass (white):</b></div>
                <div class="img-frame-tabbed">
                    <div><b>top:</b> {RenderMetadata[prefix(options)][image].white_crop[2]}, <b>bottom:</b> {RenderMetadata[prefix(options)][image].white_crop[3]}</div>
                    <div><b>left:</b> {RenderMetadata[prefix(options)][image].white_crop[0]}, <b>right:</b> {RenderMetadata[prefix(options)][image].white_crop[1]}</div>
                </div>
                <div><b>2nd pass (black):</b></div>
                <div class="img-frame-tabbed">
                    <div><b>top:</b> {RenderMetadata[prefix(options)][image].black_crop[2]}, <b>bottom:</b> {RenderMetadata[prefix(options)][image].black_crop[3]}</div>
                    <div><b>left:</b> {RenderMetadata[prefix(options)][image].black_crop[0]}, <b>right:</b> {RenderMetadata[prefix(options)][image].black_crop[1]}</div>
                </div>
            </div>
            <div class="img-frame-divider"></div>
            {/if}
            <div><b>colorized:</b> {yesno(RenderMetadata[prefix(options)][image].colorized)}</div>
            {#if RenderMetadata[prefix(options)][image].colorized}
            <div class="img-frame-tabbed">
                <div><b>multiscaled:</b> {yesno(RenderMetadata[prefix(options)][image].multiscale)}</div>
                <div><b>matching:</b> {RenderMetadata[prefix(options)][image].method}</div>
            </div>
            <div class="img-frame-divider"></div>
            <div><b>offset:</b></div>
            <div class="img-frame-tabbed">
                <div><b>blue:</b> {RenderMetadata[prefix(options)][image].bshift.map((v, i) => v + (Math.abs(v) <= 300 ? 0 : RenderMetadata[prefix(options)][image].bshape[i]))}</div>
                <div><b>red:</b> {RenderMetadata[prefix(options)][image].rshift.map((v, i) => v + (Math.abs(v) <= 300 ? 0 : RenderMetadata[prefix(options)][image].rshape[i]))}</div>
            </div>
            <div class="img-frame-divider"></div>
            {/if}
        </div>
        <div class="img-frame-controls">
            <button on:click="{() => expandHeight = !expandHeight}">
                {#if expandHeight}
                show smaller
                {:else}
                show larger
                {/if}
            </button>
            <button on:click="{() => window.open('renders/' + prefix(options) + image + '.jpg', '_blank')}">open in new tab</button>
            <button on:click="{() => enableAdvanced = !enableAdvanced}">
                {#if enableAdvanced}
                hide metadata
                {:else}
                show metadata
                {/if}
            </button>
        </div>
        <img height="{expandHeight ? 800 : 400}" alt="{prefix(options) + image}" src="renders/{prefix(options) + image + '.jpg'}" on:click="{() => expandHeight = !expandHeight}"/>
        {:else}
        <div class="img-frame-empty">
            <i>current image with these options not available</i><br/>
            <i style="font-size: .8rem;">try changing up the options above</i>
        </div>
        {/if}
    {:else}
    <div class="img-frame-empty">
        <i>invalid options selected</i><br/>
        <i style="font-size: .8rem;">try changing up the options above</i>
    </div>
    {/if}
</div>

{#if enableAdvanced && prefix(options) in RenderMetadata && image in RenderMetadata[prefix(options)]}
<div class="img-code-block">
    <pre><code>
        {JSON.stringify(RenderMetadata[prefix(options)][image], null, 2)}
    </code></pre>
</div>
{/if}

<style>
.img-frame {
    display: flex;
    position: relative;
    border: 2px solid #aaa;
    border-radius: 4px;
    box-sizing: border-box;
    margin: 0 auto;
}

.img-frame-empty {
    color: #888;
    font-size: 1.2em;
    width: 100%;
    height: 400px;
    text-align: center;
    box-sizing: border-box;
    padding: 20% 0;
}

.img-frame-divider {
    height: 4px;
}

.img-frame-tabbed {
    padding-left: 8px;
}

.img-frame-metadata {
    background: rgba(255, 255, 255, 0.6);
    border-radius: 4px;
    position: absolute;
    margin: 2px;
    padding: 10px 16px;
    top: 0;
    left: 0;
}

.img-frame-metadata h3 {
    margin: 0;
}

.img-frame-metadata div {
    color: #888;
    font-size: 0.8rem;
    margin: 2px 0;
}

.img-frame-controls {
    opacity: 0.6;
    font-size: 0.8rem;
    position: absolute;
    padding: 10px 16px;
    bottom: 0;
    left: 0;
}

img {
    margin: 0 auto;
    cursor: pointer;
}
</style>